module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xDMEkd/media/FC-9781638299882.jpg?1695340683516",
      "alt": "This image is the cover for the book Curse of the Jackal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Curse of the Jackal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Set in barbaric times, a young fisherman lives in peace on an island surrounded by warfare. At age 16, Elgin becomes a man but is soon faced with the brutality of ancient living. Innocence is swept away by violence, forcing two lovers to face life without each other. Surrounded by warring invaders, Elgin’s people must learn to fight or die.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Annon, the ascetic, is a disciplined spiritual seeker whose fate is intertwined with greater powers. Two lives are forced to experience the full range of human emotions and to rise above their circumstances. Shipwrecks, battles, and a spell-bound jackal navigate around a timeless love story between Elgin and Corina.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Elgin, with help from his wise teacher, must face his own demons while conquering his arch enemy.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christopher Lake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.3pt",
      "margin-left": ".5pt",
      "font-size": "16px",
      "font-family": "\"Georgia\",serif",
      "color": "black",
      "margin": "0mm",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "background": "white"
    }
  }, [_vm._v("Christopher Lake is an educator of 28 years and spent his formative years teaching English and History. He found an early passion for fiction in college, then enjoyed teaching middle and high school literature in public schools. His inspiration to write formed from the many impactful books that helped shape his adult life. In 2018, Chris decided to write on a regular basis to express his passion for literature.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0